module.exports = __webpack_public_path__ + "img/nft3.b7abf45e.jpg";